import React, { useCallback, useState } from 'react';
import ManagePortfoliosModal from './ManagePortfoliosModal';
import PortfolioTabs from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/PortfoliosTabs';
import PositionsTable from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PositionsTable';
import { usePortfoliosContext } from '@/finsight/application/PortfolioMonitor/PortfoliosContext';
import PortfolioForm from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm';
import { usePortfolioMonitorContext } from '@/finsight/application/PortfolioMonitor/PortfolioMonitorContext';
import getPortfolioMonitorOverlay from '@/finsight/ui/components/portfolioMonitor/getPortfolioMonitorOverlay';

import styles from './portfolioContent.scss';

const PortfolioContent = () => {
  const [isManagePortfoliosModalVisible, setIsManagePortfoliosModalVisible] = useState(false);
  const { selectedPortfolio, portfolioCollection } = usePortfoliosContext();
  const { isFormOpened } = usePortfolioMonitorContext();

  const closeManagePortfoliosModal = useCallback(() => setIsManagePortfoliosModalVisible(false), []);

  const openManagePortfoliosModal = useCallback(() => setIsManagePortfoliosModalVisible(true), []);

  const hasPortfolios = portfolioCollection.length > 0;
  const isEditing = hasPortfolios && !!selectedPortfolio?.id;

  return (
    <>
      <div className={ styles.overlay }>{ getPortfolioMonitorOverlay(true, true) }</div>
      <div className={ styles.container }>
        { hasPortfolios && <PortfolioTabs onManageClick={ openManagePortfoliosModal } /> }
        { isFormOpened ? <PortfolioForm isEditing={ isEditing } /> : <PositionsTable /> }
      </div>
      <ManagePortfoliosModal
        isVisible={ isManagePortfoliosModalVisible }
        onCancel={ closeManagePortfoliosModal }
      />
    </>
  );
};

export default PortfolioContent;
